import { render, staticRenderFns } from "./modal_composition_by_partner_type_project.vue?vue&type=template&id=8d35210e"
import script from "./modal_composition_by_partner_type_project.vue?vue&type=script&lang=js"
export * from "./modal_composition_by_partner_type_project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports